import React, { useContext, useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import Spacer from 'src/common/components/Spacer'

import './style.css'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis } from 'recharts'
import statsService from 'src/services/stats.service'
import LoadingIndicator from 'src/common/components/LoadingIndicator'
import { getPercent } from 'src/heplers'
import dayjs from 'dayjs'
import { ActiveReportingUsers } from './components/activeReportingUsers'
import Info from 'src/common/components/Info'
import { PeriodPicker } from './components/periodPicker'
import { DashBoardDateContext } from 'src/App'
import { DashboardFooterLogo } from './components/dashboardFooterLogo'
import { OnboardingStack } from '../../views/Onboarding/OnboardingStack/OnboardingStack'

export const Row = props => {
  const { children } = props
  return (
    <div className='row' {...props}>
      {children}
    </div>
  )
}
export const RowCenter = props => {
  const { children } = props
  return (
    <div className='row row-center' {...props}>
      {children}
    </div>
  )
}

export const PageTitle = ({ children }) => {
  return <h1 className='page-title'>{children}</h1>
}
export const PageHeading = ({ children }) => {
  return <div className='row row-center page-heading'>{children}</div>
}
export const DashBoardSection = ({ children }) => {
  return <div className='column dashboard-section'>{children}</div>
}
export const DashBoardSectionTitle = ({ children }) => {
  return <div className='row row-center dashboard-section-title'>{children}</div>
}
export const DashBoardSectionBlock = ({ children, style }) => {
  return (
    <div className='column dashboard-section-block' style={style}>
      {children}
    </div>
  )
}
export const DashBoardSectionBlockTitle = ({ children, style }) => {
  return (
    <div className='column dashboard-section-block-title' style={style}>
      {children}
    </div>
  )
}

export const DashBoardSectionBlockSubTitle = ({ children }) => {
  return <div className='row row-center dashboard-section-block-subtitle '>{children}</div>
}
export const DashBoardSectionlabel = ({ type = 1 }) => {
  return (
    <div className={`row row-center dashboard-section-lebel dashboard-section-lebel-${type}`}>
      <p>{type == 1 ? 'Strong' : type == 2 ? 'Average' : 'Weak'}</p>
    </div>
  )
}
export const SeeDetails = ({ text = 'See details', link }) => {
  const navigate = useNavigate()

  return (
    <div onClick={() => navigate(link)} className={`row row-center see-details`}>
      <p>{text}</p>
      <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M1.1665 7.20312L13.0415 7.20313'
          stroke='#6123FF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.4165 12.8281L13.0415 7.20312L7.4165 1.57812'
          stroke='#6123FF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </div>
  )
}

const OveralScoreIndicator = ({ score }) => {
  return (
    <div className='overal-indicator'>
      <svg
        style={{ position: 'absolute', top: -12, left: -19, zIndex: 2 }}
        width='276'
        height='154'
        viewBox='0 0 276 154'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.500909 137.5C0.50576 136.166 0.530024 134.833 0.573618 133.501L0.0738862 133.485C0.172505 130.472 0.36969 127.467 0.664498 124.474L1.16209 124.523C1.4563 121.535 1.8481 118.56 2.33654 115.602L1.84322 115.52C2.33369 112.55 2.92126 109.596 3.60497 106.663L4.09191 106.777C4.77279 103.857 5.54936 100.958 6.42069 98.0859L5.94222 97.9407C6.81532 95.0625 7.7832 92.2106 8.84494 89.3896L9.31289 89.5657C9.84086 88.1629 10.3921 86.7678 10.9666 85.381C11.541 83.9942 12.1377 82.6179 12.7563 81.2527L12.3008 81.0463C13.5448 78.3008 14.877 75.5998 16.2949 72.9473L16.7358 73.1829C18.1508 70.5357 19.6513 67.937 21.2347 65.3907L20.8101 65.1266C22.4001 62.5697 24.0733 60.0655 25.8271 57.6181L26.2336 57.9093C27.9801 55.472 29.8068 53.0912 31.7111 50.7709L31.3245 50.4537C33.2326 48.1287 35.2182 45.8643 37.2787 43.6643L37.6436 44.0061C38.6682 42.9122 39.7114 41.8342 40.7728 40.7728C41.8342 39.7114 42.9122 38.6682 44.0061 37.6436L43.6643 37.2787C45.8643 35.2182 48.1287 33.2326 50.4537 31.3246L50.7709 31.7111C53.0912 29.8068 55.472 27.9801 57.9093 26.2336L57.6181 25.8271C60.0655 24.0733 62.5697 22.4001 65.1266 20.8101L65.3907 21.2347C67.937 19.6513 70.5357 18.1508 73.1829 16.7358L72.9473 16.2949C75.5998 14.877 78.3008 13.5448 81.0463 12.3008L81.2527 12.7563C82.6179 12.1377 83.9942 11.541 85.381 10.9666C86.7678 10.3921 88.1629 9.84086 89.5657 9.31289L89.3896 8.84494C92.2106 7.7832 95.0625 6.81532 97.9407 5.94222L98.0859 6.42069C100.958 5.54936 103.857 4.77279 106.777 4.09191L106.663 3.60497C109.596 2.92126 112.55 2.33369 115.52 1.84322L115.602 2.33654C118.56 1.8481 121.535 1.45631 124.523 1.16209L124.474 0.664499C127.467 0.36969 130.472 0.172505 133.485 0.0738862L133.501 0.573619C134.999 0.524578 136.499 0.5 138 0.5C139.501 0.5 141.001 0.524578 142.499 0.573618L142.515 0.0738862C145.528 0.172505 148.533 0.36969 151.526 0.664499L151.477 1.16209C154.465 1.4563 157.44 1.8481 160.398 2.33654L160.48 1.84322C163.45 2.33369 166.404 2.92126 169.337 3.60497L169.223 4.09191C172.143 4.77279 175.042 5.54936 177.914 6.42069L178.059 5.94222C180.937 6.81532 183.789 7.7832 186.61 8.84494L186.434 9.3129C187.837 9.84086 189.232 10.3921 190.619 10.9666C192.006 11.541 193.382 12.1377 194.747 12.7563L194.954 12.3008C197.699 13.5448 200.4 14.877 203.053 16.2949L202.817 16.7358C205.464 18.1508 208.063 19.6513 210.609 21.2347L210.873 20.8101C213.43 22.4001 215.934 24.0733 218.382 25.8271L218.091 26.2336C220.528 27.9801 222.909 29.8068 225.229 31.7111L225.546 31.3245C227.871 33.2326 230.136 35.2182 232.336 37.2787L231.994 37.6436C233.088 38.6682 234.166 39.7114 235.227 40.7728C236.289 41.8342 237.332 42.9122 238.356 44.0061L238.721 43.6643C240.782 45.8643 242.767 48.1287 244.675 50.4537L244.289 50.7709C246.193 53.0912 248.02 55.472 249.766 57.9093L250.173 57.6181C251.927 60.0655 253.6 62.5697 255.19 65.1266L254.765 65.3906C256.349 67.937 257.849 70.5357 259.264 73.1829L259.705 72.9472C261.123 75.5998 262.455 78.3008 263.699 81.0463L263.244 81.2527C263.862 82.6179 264.459 83.9942 265.033 85.381C265.608 86.7678 266.159 88.1629 266.687 89.5657L267.155 89.3896C268.217 92.2105 269.185 95.0625 270.058 97.9407L269.579 98.0858C270.451 100.958 271.227 103.857 271.908 106.777L272.395 106.663C273.079 109.596 273.666 112.55 274.157 115.52L273.663 115.602C274.152 118.56 274.544 121.535 274.838 124.523L275.336 124.474C275.63 127.467 275.827 130.472 275.926 133.485L275.426 133.501C275.47 134.833 275.494 136.166 275.499 137.5H272.167V138H264.5V137.5H256.833V138H249.167V137.5H241.5V138H233.833V137.5H226.167V138H218.5V137.5H210.833V138H203.167V137.5H195.5V138H187.833V137.5H180.167V138H172.5V137.5H164.833V138H157.167V137.5H149.5V138H141.833V137.5H138H134.167V138H126.5V137.5H118.833V138H111.167V137.5H103.5V138H95.8333V137.5H88.1667V138H80.5V137.5H72.8333V138L65.1667 138V137.5H57.5V138H49.8333V137.5H42.1667V138H34.5V137.5H26.8333V138H19.1667V137.5H11.5V138H3.83334V137.5H0.500909Z'
          stroke='#E7E8EA'
          strokeDasharray='8 8'
        />
        <path
          d='M162 129C162 125.717 161.353 122.466 160.097 119.433C158.841 116.4 156.999 113.644 154.678 111.322C152.356 109.001 149.6 107.159 146.567 105.903C143.534 104.647 140.283 104 137 104C133.717 104 130.466 104.647 127.433 105.903C124.4 107.159 121.644 109.001 119.322 111.322C117.001 113.644 115.159 116.4 113.903 119.433C112.647 122.466 112 125.717 112 129L137 129H162Z'
          fill='#F5F5FA'
        />
        <path
          d='M162 129C162 125.717 161.353 122.466 160.097 119.433C158.841 116.4 156.999 113.644 154.678 111.322C152.356 109.001 149.6 107.159 146.567 105.903C143.534 104.647 140.283 104 137 104C133.717 104 130.466 104.647 127.433 105.903C124.4 107.159 121.644 109.001 119.322 111.322C117.001 113.644 115.159 116.4 113.903 119.433C112.647 122.466 112 125.717 112 129L137 129H162Z'
          fill='url(#paint0_linear_515_2462)'
          fillOpacity='0.1'
        />
        <path
          d='M159.173 119.816C160.252 122.419 160.862 125.19 160.979 128H137L113.021 128C113.138 125.19 113.748 122.419 114.827 119.816C116.033 116.904 117.801 114.258 120.029 112.029C122.258 109.801 124.904 108.033 127.816 106.827C130.727 105.621 133.848 105 137 105C140.152 105 143.273 105.621 146.184 106.827C149.096 108.033 151.742 109.801 153.971 112.029C156.199 114.258 157.967 116.904 159.173 119.816Z'
          stroke='url(#paint1_linear_515_2462)'
          strokeOpacity='0.5'
          strokeWidth='2'
        />
        <defs>
          <linearGradient
            id='paint0_linear_515_2462'
            x1='137'
            y1='76'
            x2='135.601'
            y2='130.202'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#6123FF' />
            <stop offset='1' stopColor='white' stopOpacity='0' />
          </linearGradient>
          <linearGradient
            id='paint1_linear_515_2462'
            x1='137'
            y1='76'
            x2='135.601'
            y2='130.202'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#6123FF' />
            <stop offset='1' stopColor='white' stopOpacity='0' />
          </linearGradient>
        </defs>
      </svg>

      <div
        style={{
          position: 'absolute',
          width: 50,
          height: 20,
          left: 92,
          bottom: -7,
          zIndex: 10,
          background: '#fff'
        }}
      ></div>

      <svg
        style={{
          position: 'absolute',
          transition: '300ms',
          bottom: 0,
          left: 70,
          transform: `rotate(${1.8 * score < 20 ? 20 : 1.8 * score > 160 ? 160 : 1.8 * score}deg)`,
          zIndex: 1
        }}
        width='98'
        height='20'
        viewBox='0 0 98 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M4.56055e-08 10.2432L39 1L39 19L4.56055e-08 10.2432Z' fill='black' />
      </svg>

      {score < 33 ? (
        <svg width='244' height='123' viewBox='0 0 244 123' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M4.66468 113.59C6.41559 80.0732 22.0143 50.2552 45.9004 29.7264C47.4536 28.3915 47.8828 28.0687 48.356 27.9421C48.8165 27.8189 49.3782 27.8401 49.8281 27.9977C50.02 28.0648 50.2516 28.1927 50.6372 28.5197C51.0404 28.8618 51.5206 29.3403 52.2445 30.0642L80.0984 57.9181C81.0812 58.9009 81.7563 59.5775 82.2283 60.1287C82.7001 60.6796 82.8491 60.9725 82.9033 61.1578C83.0788 61.7588 83.056 62.215 82.8215 62.7955C82.7551 62.9597 82.5667 63.2519 81.9763 63.8094C81.3963 64.3572 80.5757 65.0296 79.3975 65.9933C65.3829 77.4564 55.8904 94.2929 54.1114 113.379C53.9957 114.621 53.9151 115.476 53.8107 116.121C53.7058 116.769 53.5987 117.045 53.5136 117.188C53.2341 117.658 52.9311 117.934 52.437 118.169C52.2739 118.246 52.0041 118.323 51.4192 118.366C50.8252 118.41 50.0501 118.411 48.9085 118.411H9.4C8.25831 118.411 7.4978 118.409 6.91033 118.358C6.34565 118.309 6.06922 118.222 5.87713 118.12C5.42 117.878 4.99719 117.433 4.77936 116.963C4.68409 116.758 4.61355 116.485 4.59323 115.954C4.57184 115.394 4.60786 114.677 4.66468 113.59Z'
            fill='#F1F1F8'
          />
          <path
            d='M4.66468 113.59C6.41559 80.0732 22.0143 50.2552 45.9004 29.7264C47.4536 28.3915 47.8828 28.0687 48.356 27.9421C48.8165 27.8189 49.3782 27.8401 49.8281 27.9977C50.02 28.0648 50.2516 28.1927 50.6372 28.5197C51.0404 28.8618 51.5206 29.3403 52.2445 30.0642L80.0984 57.9181C81.0812 58.9009 81.7563 59.5775 82.2283 60.1287C82.7001 60.6796 82.8491 60.9725 82.9033 61.1578C83.0788 61.7588 83.056 62.215 82.8215 62.7955C82.7551 62.9597 82.5667 63.2519 81.9763 63.8094C81.3963 64.3572 80.5757 65.0296 79.3975 65.9933C65.3829 77.4564 55.8904 94.2929 54.1114 113.379C53.9957 114.621 53.9151 115.476 53.8107 116.121C53.7058 116.769 53.5987 117.045 53.5136 117.188C53.2341 117.658 52.9311 117.934 52.437 118.169C52.2739 118.246 52.0041 118.323 51.4192 118.366C50.8252 118.41 50.0501 118.411 48.9085 118.411H9.4C8.25831 118.411 7.4978 118.409 6.91033 118.358C6.34565 118.309 6.06922 118.222 5.87713 118.12C5.42 117.878 4.99719 117.433 4.77936 116.963C4.68409 116.758 4.61355 116.485 4.59323 115.954C4.57184 115.394 4.60786 114.677 4.66468 113.59Z'
            fill='#DE1E41'
          />
          <path
            d='M4.66468 113.59C6.41559 80.0732 22.0143 50.2552 45.9004 29.7264C47.4536 28.3915 47.8828 28.0687 48.356 27.9421C48.8165 27.8189 49.3782 27.8401 49.8281 27.9977C50.02 28.0648 50.2516 28.1927 50.6372 28.5197C51.0404 28.8618 51.5206 29.3403 52.2445 30.0642L80.0984 57.9181C81.0812 58.9009 81.7563 59.5775 82.2283 60.1287C82.7001 60.6796 82.8491 60.9725 82.9033 61.1578C83.0788 61.7588 83.056 62.215 82.8215 62.7955C82.7551 62.9597 82.5667 63.2519 81.9763 63.8094C81.3963 64.3572 80.5757 65.0296 79.3975 65.9933C65.3829 77.4564 55.8904 94.2929 54.1114 113.379C53.9957 114.621 53.9151 115.476 53.8107 116.121C53.7058 116.769 53.5987 117.045 53.5136 117.188C53.2341 117.658 52.9311 117.934 52.437 118.169C52.2739 118.246 52.0041 118.323 51.4192 118.366C50.8252 118.41 50.0501 118.411 48.9085 118.411H9.4C8.25831 118.411 7.4978 118.409 6.91033 118.358C6.34565 118.309 6.06922 118.222 5.87713 118.12C5.42 117.878 4.99719 117.433 4.77936 116.963C4.68409 116.758 4.61355 116.485 4.59323 115.954C4.57184 115.394 4.60786 114.677 4.66468 113.59Z'
            stroke='white'
            strokeWidth='3'
          />
          <path
            d='M43.945 27.4512C19.4607 48.4942 3.46404 79.0674 1.66877 113.433L1.66541 113.497C1.61282 114.504 1.56822 115.357 1.59542 116.068C1.62429 116.823 1.73523 117.531 2.05837 118.227C2.55203 119.29 3.4375 120.223 4.47347 120.771C5.15943 121.135 5.87979 121.28 6.65018 121.347C7.38315 121.411 8.27495 121.411 9.3363 121.411H9.4H48.9085H48.9645C50.036 121.411 50.9214 121.411 51.6379 121.358C52.3757 121.304 53.0727 121.188 53.724 120.879C54.756 120.389 55.5087 119.703 56.0924 118.721C56.468 118.089 56.648 117.367 56.7721 116.601C56.8947 115.843 56.9839 114.886 57.0934 113.712L57.0984 113.658C58.8 95.4016 67.8792 79.2903 81.2969 68.3154L81.3429 68.2778C82.4644 67.3605 83.3689 66.6207 84.0361 65.9905C84.7021 65.3616 85.2857 64.7045 85.603 63.9194C86.0903 62.7136 86.1476 61.565 85.7829 60.3166C85.55 59.5191 85.0726 58.8378 84.5069 58.1773C83.9503 57.5273 83.192 56.769 82.2635 55.8405L82.2197 55.7967L54.3658 27.9429L54.3241 27.9012C53.6529 27.23 53.0861 26.663 52.5778 26.2319C52.0413 25.7769 51.489 25.4006 50.8195 25.1662C49.8008 24.8095 48.6236 24.7651 47.5809 25.044C46.3612 25.3702 45.3885 26.208 44.1599 27.2663C44.0891 27.3272 44.0175 27.3889 43.945 27.4512Z'
            stroke='#DE1E41'
            strokeWidth='3'
          />
          <path
            d='M237.429 120.911C239.66 120.911 240.775 120.911 241.654 120.446C242.4 120.05 243.054 119.361 243.41 118.595C243.828 117.694 243.773 116.633 243.662 114.511V114.511C241.884 80.5731 226.05 50.3796 201.905 29.5939L201.905 29.5939C200.462 28.3522 199.741 27.7313 198.86 27.4948C198.108 27.2932 197.238 27.3255 196.504 27.5822C195.642 27.8833 194.935 28.5899 193.52 30.003L165.642 57.852C163.708 59.7848 162.74 60.7513 162.453 61.7347C162.182 62.6601 162.222 63.4628 162.584 64.3566C162.968 65.3065 164.131 66.2564 166.456 68.1563C180.188 79.3752 189.451 95.8483 191.186 114.519C191.413 116.959 191.526 118.179 191.987 118.954C192.418 119.68 192.947 120.161 193.71 120.524C194.524 120.911 195.643 120.911 197.882 120.911H237.429Z'
            fill='url(#paint0_linear_86_18)'
          />
          <path
            d='M237.429 120.911C239.66 120.911 240.775 120.911 241.654 120.446C242.4 120.05 243.054 119.361 243.41 118.595C243.828 117.694 243.773 116.633 243.662 114.511V114.511C241.884 80.5731 226.05 50.3796 201.905 29.5939L201.905 29.5939C200.462 28.3522 199.741 27.7313 198.86 27.4948C198.108 27.2932 197.238 27.3255 196.504 27.5822C195.642 27.8833 194.935 28.5899 193.52 30.003L165.642 57.852C163.708 59.7848 162.74 60.7513 162.453 61.7347C162.182 62.6601 162.222 63.4628 162.584 64.3566C162.968 65.3065 164.131 66.2564 166.456 68.1563C180.188 79.3752 189.451 95.8483 191.186 114.519C191.413 116.959 191.526 118.179 191.987 118.954C192.418 119.68 192.947 120.161 193.71 120.524C194.524 120.911 195.643 120.911 197.882 120.911H237.429Z'
            stroke='white'
          />
          <path
            d='M188.573 27.7144C190.4 25.8873 191.314 24.9737 191.583 23.9001C191.81 22.9922 191.689 21.9336 191.261 21.1009C190.756 20.1163 189.713 19.4676 187.628 18.1703C169.137 6.66583 147.322 0 123.955 0C100.587 0 78.7403 6.66631 60.28 18.1715C58.2001 19.4678 57.1602 20.1159 56.6554 21.0999C56.2286 21.9319 56.1072 22.9902 56.3343 23.8973C56.603 24.9701 57.5145 25.8826 59.3377 27.7076L88.5631 56.9629C89.7641 58.1651 90.3646 58.7662 91.0321 59.0673C91.6566 59.3491 92.2288 59.4547 92.9128 59.4143C93.6438 59.3711 94.4922 58.9911 96.1891 58.2311C104.666 54.4342 114.048 52.3471 123.955 52.3471C133.856 52.3471 143.241 54.4315 151.692 58.2236C153.393 58.9865 154.243 59.3679 154.974 59.4115C155.658 59.4524 156.23 59.3473 156.855 59.0657C157.523 58.7649 158.124 58.1634 159.327 56.9605L188.573 27.7144Z'
            fill='#F1F1F8'
          />
          <path
            d='M188.573 27.7144C190.4 25.8873 191.314 24.9737 191.583 23.9001C191.81 22.9922 191.689 21.9336 191.261 21.1009C190.756 20.1163 189.713 19.4676 187.628 18.1703C169.137 6.66583 147.322 0 123.955 0C100.587 0 78.7403 6.66631 60.28 18.1715C58.2001 19.4678 57.1602 20.1159 56.6554 21.0999C56.2286 21.9319 56.1072 22.9902 56.3343 23.8973C56.603 24.9701 57.5145 25.8826 59.3377 27.7076L88.5631 56.9629C89.7641 58.1651 90.3646 58.7662 91.0321 59.0673C91.6566 59.3491 92.2288 59.4547 92.9128 59.4143C93.6438 59.3711 94.4922 58.9911 96.1891 58.2311C104.666 54.4342 114.048 52.3471 123.955 52.3471C133.856 52.3471 143.241 54.4315 151.692 58.2236C153.393 58.9865 154.243 59.3679 154.974 59.4115C155.658 59.4524 156.23 59.3473 156.855 59.0657C157.523 58.7649 158.124 58.1634 159.327 56.9605L188.573 27.7144Z'
            fill='#F7C604'
          />
          <path
            d='M188.573 27.7144C190.4 25.8873 191.314 24.9737 191.583 23.9001C191.81 22.9922 191.689 21.9336 191.261 21.1009C190.756 20.1163 189.713 19.4676 187.628 18.1703C169.137 6.66583 147.322 0 123.955 0C100.587 0 78.7403 6.66631 60.28 18.1715C58.2001 19.4678 57.1602 20.1159 56.6554 21.0999C56.2286 21.9319 56.1072 22.9902 56.3343 23.8973C56.603 24.9701 57.5145 25.8826 59.3377 27.7076L88.5631 56.9629C89.7641 58.1651 90.3646 58.7662 91.0321 59.0673C91.6566 59.3491 92.2288 59.4547 92.9128 59.4143C93.6438 59.3711 94.4922 58.9911 96.1891 58.2311C104.666 54.4342 114.048 52.3471 123.955 52.3471C133.856 52.3471 143.241 54.4315 151.692 58.2236C153.393 58.9865 154.243 59.3679 154.974 59.4115C155.658 59.4524 156.23 59.3473 156.855 59.0657C157.523 58.7649 158.124 58.1634 159.327 56.9605L188.573 27.7144Z'
            stroke='white'
          />
          <defs>
            <linearGradient id='paint0_linear_86_18' x1='230' y1='59' x2='169' y2='92' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#13CE76' />
              <stop offset='1' stopColor='#11BD6C' />
            </linearGradient>
          </defs>
        </svg>
      ) : score > 66 ? (
        <svg width='244' height='124' viewBox='0 0 244 124' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M50.3052 29.0035C48.8918 27.5902 48.1851 26.8835 47.3238 26.5819C46.5895 26.3248 45.72 26.292 44.9685 26.493C44.0869 26.7288 43.3655 27.3488 41.9227 28.5888C17.7375 49.3747 1.93981 79.5703 0.166727 113.511C0.0558831 115.633 0.000460997 116.694 0.418865 117.595C0.774611 118.361 1.42875 119.05 2.1753 119.446C3.05335 119.911 4.1689 119.911 6.4 119.911H45.9085C48.1469 119.911 49.2661 119.911 50.0805 119.524C50.8435 119.161 51.3714 118.681 51.803 117.954C52.2637 117.179 52.3774 115.959 52.6049 113.519C54.3452 94.8473 63.631 78.3733 77.3472 67.1543C79.6681 65.256 80.8286 64.3068 81.2122 63.3574C81.5732 62.4643 81.6132 61.6619 81.3431 60.7372C81.056 59.7544 80.0903 58.7887 78.159 56.8574L50.3052 29.0035Z'
            fill='#F1F1F8'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M50.3052 29.0035C48.8918 27.5902 48.1851 26.8835 47.3238 26.5819C46.5895 26.3248 45.72 26.292 44.9685 26.493C44.0869 26.7288 43.3655 27.3488 41.9227 28.5888C17.7375 49.3747 1.93981 79.5703 0.166727 113.511C0.0558831 115.633 0.000460997 116.694 0.418865 117.595C0.774611 118.361 1.42875 119.05 2.1753 119.446C3.05335 119.911 4.1689 119.911 6.4 119.911H45.9085C48.1469 119.911 49.2661 119.911 50.0805 119.524C50.8435 119.161 51.3714 118.681 51.803 117.954C52.2637 117.179 52.3774 115.959 52.6049 113.519C54.3452 94.8473 63.631 78.3733 77.3472 67.1543C79.6681 65.256 80.8286 64.3068 81.2122 63.3574C81.5732 62.4643 81.6132 61.6619 81.3431 60.7372C81.056 59.7544 80.0903 58.7887 78.159 56.8574L50.3052 29.0035Z'
            fill='#DE1E41'
          />
          <path
            d='M46.8281 27.9977C47.02 28.0648 47.2516 28.1927 47.6372 28.5197C48.0404 28.8618 48.5206 29.3403 49.2445 30.0642L77.0984 57.9181C78.0812 58.9009 78.7563 59.5775 79.2283 60.1287C79.7001 60.6796 79.8491 60.9725 79.9033 61.1578C80.0788 61.7588 80.056 62.215 79.8215 62.7955C79.7551 62.9597 79.5667 63.2519 78.9763 63.8094C78.3963 64.3572 77.5757 65.0296 76.3975 65.9933C62.3829 77.4564 52.8904 94.2929 51.1114 113.379C50.9956 114.621 50.9151 115.476 50.8107 116.121C50.7058 116.769 50.5987 117.045 50.5136 117.188C50.2341 117.658 49.9311 117.934 49.437 118.169C49.2739 118.246 49.0041 118.323 48.4192 118.366C47.8252 118.41 47.0501 118.411 45.9085 118.411H6.4C5.25831 118.411 4.4978 118.409 3.91033 118.358C3.34565 118.309 3.06922 118.222 2.87713 118.12C2.42 117.878 1.99719 117.433 1.77936 116.963C1.68409 116.758 1.61355 116.485 1.59323 115.954C1.57184 115.394 1.60786 114.677 1.66468 113.59C3.41559 80.0732 19.0143 50.2552 42.9004 29.7264C44.4536 28.3915 44.8828 28.0687 45.356 27.9421C45.8165 27.8189 46.3782 27.8401 46.8281 27.9977Z'
            stroke='#1B1B26'
            strokeOpacity='0.02'
            strokeWidth='3'
          />
          <path
            d='M234.429 122.2H234.485C235.553 122.2 236.437 122.2 237.16 122.137C237.916 122.071 238.605 121.93 239.257 121.585C240.252 121.058 241.105 120.159 241.579 119.138C241.886 118.476 241.994 117.799 242.023 117.06C242.049 116.358 242.005 115.513 241.952 114.5L241.949 114.444C240.152 80.14 224.147 49.6227 199.746 28.617C199.679 28.5595 199.613 28.5027 199.548 28.4467C198.301 27.3714 197.365 26.5641 196.194 26.2498C195.192 25.9811 194.058 26.0232 193.078 26.3653C192.442 26.5876 191.912 26.9463 191.386 27.3921C190.884 27.8175 190.322 28.379 189.646 29.0543L189.609 29.091L190.472 29.955L189.609 29.091L161.731 56.94L161.693 56.9783C160.758 57.9122 160.003 58.6662 159.451 59.3104C158.891 59.9636 158.436 60.618 158.215 61.373C157.864 62.5768 157.919 63.6771 158.389 64.8398C158.689 65.5818 159.246 66.2136 159.907 66.8379C160.57 67.4633 161.472 68.1997 162.601 69.1219L162.641 69.1546C176.115 80.1629 185.2 96.3237 186.903 114.638L186.907 114.685C187.017 115.865 187.105 116.816 187.226 117.566C187.349 118.324 187.524 119.015 187.879 119.612C188.441 120.558 189.162 121.216 190.157 121.688C190.774 121.981 191.441 122.095 192.168 122.148C192.876 122.2 193.755 122.2 194.833 122.2H194.882H234.429Z'
            stroke='url(#paint0_linear_523_4782)'
            strokeWidth='2.57804'
          />
          <path
            d='M237.952 119.12C237.76 119.222 237.483 119.309 236.919 119.358C236.331 119.409 235.571 119.411 234.429 119.411H194.882C193.74 119.411 192.965 119.41 192.371 119.366C191.786 119.323 191.516 119.246 191.353 119.169C190.859 118.934 190.556 118.658 190.277 118.188C190.191 118.044 190.084 117.768 189.98 117.121C189.875 116.476 189.795 115.621 189.68 114.38C187.906 95.2951 178.437 78.4587 164.405 66.9947C163.225 66.0303 162.402 65.3573 161.821 64.809C161.229 64.2509 161.041 63.9584 160.974 63.7943C160.739 63.2133 160.717 62.757 160.892 62.1556C160.947 61.9702 161.096 61.6771 161.569 61.1257C162.042 60.574 162.718 59.8968 163.703 58.9132L191.58 31.0642C192.305 30.3404 192.785 29.8619 193.189 29.52C193.575 29.193 193.807 29.0653 193.999 28.9982C194.449 28.8409 195.01 28.8201 195.471 28.9436C195.944 29.0706 196.373 29.3939 197.926 30.7307C221.774 51.2603 237.408 81.077 239.164 114.59C239.221 115.677 239.257 116.394 239.236 116.954C239.215 117.485 239.145 117.758 239.049 117.963C238.832 118.432 238.409 118.878 237.952 119.12Z'
            fill='url(#paint1_linear_523_4782)'
            stroke='white'
            strokeWidth='3'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M184.573 27.7144C186.4 25.8873 187.314 24.9737 187.583 23.9001C187.81 22.9922 187.689 21.9336 187.261 21.1009C186.756 20.1163 185.713 19.4676 183.628 18.1703C165.137 6.66583 143.322 0 119.955 0C96.5869 0 74.7403 6.66631 56.28 18.1715C54.2001 19.4678 53.1602 20.1159 52.6554 21.0999C52.2286 21.9319 52.1072 22.9902 52.3343 23.8973C52.603 24.9701 53.5145 25.8826 55.3377 27.7076L84.5631 56.9629C85.7641 58.1651 86.3646 58.7662 87.0321 59.0673C87.6566 59.3491 88.2288 59.4547 88.9128 59.4143C89.6438 59.3711 90.4922 58.9911 92.1891 58.2311C100.666 54.4342 110.048 52.3471 119.955 52.3471C129.856 52.3471 139.241 54.4315 147.692 58.2236C149.393 58.9865 150.243 59.3679 150.974 59.4115C151.658 59.4524 152.23 59.3473 152.855 59.0657C153.523 58.7649 154.124 58.1634 155.327 56.9605L184.573 27.7144Z'
            fill='#F1F1F8'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M184.573 27.7144C186.4 25.8873 187.314 24.9737 187.583 23.9001C187.81 22.9922 187.689 21.9336 187.261 21.1009C186.756 20.1163 185.713 19.4676 183.628 18.1703C165.137 6.66583 143.322 0 119.955 0C96.5869 0 74.7403 6.66631 56.28 18.1715C54.2001 19.4678 53.1602 20.1159 52.6554 21.0999C52.2286 21.9319 52.1072 22.9902 52.3343 23.8973C52.603 24.9701 53.5145 25.8826 55.3377 27.7076L84.5631 56.9629C85.7641 58.1651 86.3646 58.7662 87.0321 59.0673C87.6566 59.3491 88.2288 59.4547 88.9128 59.4143C89.6438 59.3711 90.4922 58.9911 92.1891 58.2311C100.666 54.4342 110.048 52.3471 119.955 52.3471C129.856 52.3471 139.241 54.4315 147.692 58.2236C149.393 58.9865 150.243 59.3679 150.974 59.4115C151.658 59.4524 152.23 59.3473 152.855 59.0657C153.523 58.7649 154.124 58.1634 155.327 56.9605L184.573 27.7144Z'
            fill='#F7C604'
          />
          <path
            d='M186.128 23.5356C186.071 23.7638 185.93 24.0582 185.508 24.5668C185.073 25.0916 184.446 25.7201 183.513 26.6537L154.266 55.8998C153.652 56.5147 153.239 56.9261 152.899 57.2256C152.569 57.5167 152.38 57.6345 152.239 57.698C151.835 57.8801 151.506 57.9406 151.063 57.9142C150.921 57.9057 150.691 57.8603 150.229 57.685C149.764 57.5082 149.173 57.2439 148.307 56.855C139.662 52.9766 130.069 50.8471 119.955 50.8471C109.835 50.8471 100.245 52.9796 91.576 56.8621C90.7111 57.2495 90.1218 57.5127 89.6572 57.6888C89.1969 57.8632 88.9673 57.9084 88.8244 57.9169C88.3825 57.943 88.0524 57.8821 87.6489 57.7C87.5079 57.6364 87.3194 57.5185 86.9895 57.2278C86.6499 56.9284 86.2383 56.5173 85.6243 55.9028L56.3989 26.6475C55.4672 25.7149 54.8424 25.0873 54.4079 24.5631C53.9869 24.0553 53.8465 23.7612 53.7894 23.5329C53.6505 22.9785 53.7292 22.293 53.9901 21.7846L52.6741 21.1095L53.9901 21.7846C54.1022 21.566 54.3 21.3186 54.7898 20.9432C55.3017 20.5506 56.0086 20.1081 57.0733 19.4445C75.3028 8.08325 96.8756 1.5 119.955 1.5C143.033 1.5 164.575 8.08247 182.835 19.4439C183.903 20.108 184.612 20.551 185.125 20.944C185.616 21.32 185.815 21.5676 185.927 21.7861C186.188 22.295 186.267 22.9805 186.128 23.5356Z'
            stroke='#1B1B26'
            strokeOpacity='0.02'
            strokeWidth='3'
          />
          <defs>
            <linearGradient
              id='paint0_linear_523_4782'
              x1='225.5'
              y1='61.4922'
              x2='173.5'
              y2='90.4922'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#11BD6C' />
              <stop offset='1' stopColor='#10B266' />
            </linearGradient>
            <linearGradient
              id='paint1_linear_523_4782'
              x1='227'
              y1='59'
              x2='166'
              y2='92'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#13CE76' />
              <stop offset='1' stopColor='#11BD6C' />
            </linearGradient>
          </defs>
        </svg>
      ) : (
        <svg width='241' height='124' viewBox='0 0 241 124' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M50.3052 32.0035C48.8918 30.5902 48.1851 29.8835 47.3238 29.5819C46.5895 29.3248 45.72 29.292 44.9685 29.493C44.0869 29.7288 43.3655 30.3488 41.9227 31.5888C17.7375 52.3747 1.93981 82.5703 0.166727 116.511C0.0558831 118.633 0.000460997 119.694 0.418865 120.595C0.774611 121.361 1.42875 122.05 2.1753 122.446C3.05335 122.911 4.1689 122.911 6.4 122.911H45.9085C48.1469 122.911 49.2661 122.911 50.0805 122.524C50.8435 122.161 51.3714 121.681 51.803 120.954C52.2637 120.179 52.3774 118.959 52.6049 116.519C54.3452 97.8473 63.631 81.3733 77.3472 70.1543C79.6681 68.256 80.8286 67.3068 81.2122 66.3574C81.5731 65.4643 81.6132 64.6619 81.3431 63.7372C81.056 62.7544 80.0903 61.7887 78.159 59.8574L50.3052 32.0035Z'
            fill='#F1F1F8'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M50.3052 32.0035C48.8918 30.5902 48.1851 29.8835 47.3238 29.5819C46.5895 29.3248 45.72 29.292 44.9685 29.493C44.0869 29.7288 43.3655 30.3488 41.9227 31.5888C17.7375 52.3747 1.93981 82.5703 0.166727 116.511C0.0558831 118.633 0.000460997 119.694 0.418865 120.595C0.774611 121.361 1.42875 122.05 2.1753 122.446C3.05335 122.911 4.1689 122.911 6.4 122.911H45.9085C48.1469 122.911 49.2661 122.911 50.0805 122.524C50.8435 122.161 51.3714 121.681 51.803 120.954C52.2637 120.179 52.3774 118.959 52.6049 116.519C54.3452 97.8473 63.631 81.3733 77.3472 70.1543C79.6681 68.256 80.8286 67.3068 81.2122 66.3574C81.5731 65.4643 81.6132 64.6619 81.3431 63.7372C81.056 62.7544 80.0903 61.7887 78.159 59.8574L50.3052 32.0035Z'
            fill='#DE1E41'
          />
          <path
            d='M1.66468 116.59C3.41559 83.0732 19.0143 53.2552 42.9004 32.7264C44.4536 31.3915 44.8828 31.0687 45.356 30.9421C45.8165 30.8189 46.3782 30.8401 46.8281 30.9977C47.02 31.0648 47.2516 31.1927 47.6372 31.5197C48.0404 31.8618 48.5206 32.3403 49.2445 33.0642L77.0984 60.9181C78.0812 61.9009 78.7563 62.5775 79.2283 63.1287C79.7001 63.6796 79.8491 63.9725 79.9033 64.1578C80.0788 64.7588 80.056 65.215 79.8215 65.7955C79.7551 65.9597 79.5667 66.2519 78.9763 66.8094C78.3963 67.3572 77.5757 68.0296 76.3975 68.9933C62.3829 80.4564 52.8904 97.2929 51.1114 116.379C50.9957 117.621 50.9151 118.476 50.8107 119.121C50.7058 119.769 50.5987 120.045 50.5136 120.188C50.2341 120.658 49.9311 120.934 49.437 121.169C49.2739 121.246 49.0041 121.323 48.4192 121.366C47.8252 121.41 47.0501 121.411 45.9085 121.411H6.4C5.25831 121.411 4.4978 121.409 3.91033 121.358C3.34565 121.309 3.06922 121.222 2.87713 121.12C2.42 120.878 1.99719 120.433 1.77936 119.963C1.68409 119.758 1.61355 119.485 1.59323 118.954C1.57184 118.394 1.60786 117.677 1.66468 116.59Z'
            stroke='#1B1B26'
            strokeOpacity='0.02'
          />
          <path
            d='M234.429 123.911C236.66 123.911 237.775 123.911 238.654 123.446C239.4 123.05 240.054 122.361 240.41 121.595C240.828 120.694 240.773 119.633 240.662 117.511V117.511C238.884 83.5731 223.05 53.3796 198.905 32.5939L198.905 32.5939C197.462 31.3522 196.741 30.7313 195.86 30.4948C195.108 30.2932 194.238 30.3255 193.504 30.5822C192.642 30.8833 191.935 31.5899 190.52 33.003L162.642 60.852C160.708 62.7848 159.74 63.7513 159.453 64.7347C159.182 65.6601 159.222 66.4628 159.584 67.3566C159.968 68.3065 161.131 69.2564 163.456 71.1563C177.188 82.3752 186.451 98.8483 188.186 117.519C188.413 119.959 188.526 121.179 188.987 121.954C189.418 122.68 189.947 123.161 190.71 123.524C191.524 123.911 192.643 123.911 194.882 123.911H234.429Z'
            fill='url(#paint0_linear_78_12)'
          />
          <path
            d='M234.429 123.911C236.66 123.911 237.775 123.911 238.654 123.446C239.4 123.05 240.054 122.361 240.41 121.595C240.828 120.694 240.773 119.633 240.662 117.511V117.511C238.884 83.5731 223.05 53.3796 198.905 32.5939L198.905 32.5939C197.462 31.3522 196.741 30.7313 195.86 30.4948C195.108 30.2932 194.238 30.3255 193.504 30.5822C192.642 30.8833 191.935 31.5899 190.52 33.003L162.642 60.852C160.708 62.7848 159.74 63.7513 159.453 64.7347C159.182 65.6601 159.222 66.4628 159.584 67.3566C159.968 68.3065 161.131 69.2564 163.456 71.1563C177.188 82.3752 186.451 98.8483 188.186 117.519C188.413 119.959 188.526 121.179 188.987 121.954C189.418 122.68 189.947 123.161 190.71 123.524C191.524 123.911 192.643 123.911 194.882 123.911H234.429Z'
            stroke='white'
          />
          <path
            d='M120.955 4.5C144.033 4.5 165.575 11.0825 183.835 22.4439C184.903 23.108 185.612 23.551 186.125 23.944C186.616 24.32 186.815 24.5676 186.927 24.7861C187.188 25.2951 187.267 25.9805 187.128 26.5356C187.071 26.7638 186.93 27.0582 186.508 27.5668C186.073 28.0916 185.446 28.7201 184.513 29.6537L155.266 58.8998C154.652 59.5147 154.239 59.9261 153.899 60.2256C153.569 60.5167 153.38 60.6345 153.239 60.698C152.835 60.8801 152.506 60.9406 152.063 60.9142C151.921 60.9057 151.691 60.8603 151.229 60.685C150.764 60.5082 150.173 60.2439 149.307 59.855C140.662 55.9766 131.069 53.8471 120.955 53.8471C110.835 53.8471 101.245 55.9796 92.576 59.8621C91.7111 60.2495 91.1218 60.5127 90.6572 60.6888C90.1969 60.8632 89.9673 60.9084 89.8244 60.9169C89.3825 60.943 89.0524 60.8821 88.6489 60.7C88.5079 60.6364 88.3194 60.5185 87.9895 60.2278C87.6499 59.9284 87.2383 59.5173 86.6243 58.9028L57.3989 29.6475C56.4672 28.7149 55.8424 28.0873 55.4079 27.5631C54.9869 27.0553 54.8465 26.7612 54.7894 26.5329C54.6505 25.9785 54.7292 25.293 54.9901 24.7846C55.1022 24.566 55.3 24.3186 55.7898 23.9432C56.3017 23.5506 57.0086 23.1081 58.0733 22.4445C76.3028 11.0833 97.8756 4.5 120.955 4.5Z'
            fill='#F1F1F8'
          />
          <path
            d='M120.955 4.5C144.033 4.5 165.575 11.0825 183.835 22.4439C184.903 23.108 185.612 23.551 186.125 23.944C186.616 24.32 186.815 24.5676 186.927 24.7861C187.188 25.2951 187.267 25.9805 187.128 26.5356C187.071 26.7638 186.93 27.0582 186.508 27.5668C186.073 28.0916 185.446 28.7201 184.513 29.6537L155.266 58.8998C154.652 59.5147 154.239 59.9261 153.899 60.2256C153.569 60.5167 153.38 60.6345 153.239 60.698C152.835 60.8801 152.506 60.9406 152.063 60.9142C151.921 60.9057 151.691 60.8603 151.229 60.685C150.764 60.5082 150.173 60.2439 149.307 59.855C140.662 55.9766 131.069 53.8471 120.955 53.8471C110.835 53.8471 101.245 55.9796 92.576 59.8621C91.7111 60.2495 91.1218 60.5127 90.6572 60.6888C90.1969 60.8632 89.9673 60.9084 89.8244 60.9169C89.3825 60.943 89.0524 60.8821 88.6489 60.7C88.5079 60.6364 88.3194 60.5185 87.9895 60.2278C87.6499 59.9284 87.2383 59.5173 86.6243 58.9028L57.3989 29.6475C56.4672 28.7149 55.8424 28.0873 55.4079 27.5631C54.9869 27.0553 54.8465 26.7612 54.7894 26.5329C54.6505 25.9785 54.7292 25.293 54.9901 24.7846C55.1022 24.566 55.3 24.3186 55.7898 23.9432C56.3017 23.5506 57.0086 23.1081 58.0733 22.4445C76.3028 11.0833 97.8756 4.5 120.955 4.5Z'
            fill='#F7C604'
          />
          <path
            d='M120.955 4.5C144.033 4.5 165.575 11.0825 183.835 22.4439C184.903 23.108 185.612 23.551 186.125 23.944C186.616 24.32 186.815 24.5676 186.927 24.7861C187.188 25.2951 187.267 25.9805 187.128 26.5356C187.071 26.7638 186.93 27.0582 186.508 27.5668C186.073 28.0916 185.446 28.7201 184.513 29.6537L155.266 58.8998C154.652 59.5147 154.239 59.9261 153.899 60.2256C153.569 60.5167 153.38 60.6345 153.239 60.698C152.835 60.8801 152.506 60.9406 152.063 60.9142C151.921 60.9057 151.691 60.8603 151.229 60.685C150.764 60.5082 150.173 60.2439 149.307 59.855C140.662 55.9766 131.069 53.8471 120.955 53.8471C110.835 53.8471 101.245 55.9796 92.576 59.8621C91.7111 60.2495 91.1218 60.5127 90.6572 60.6888C90.1969 60.8632 89.9673 60.9084 89.8244 60.9169C89.3825 60.943 89.0524 60.8821 88.6489 60.7C88.5079 60.6364 88.3194 60.5185 87.9895 60.2278C87.6499 59.9284 87.2383 59.5173 86.6243 58.9028L57.3989 29.6475C56.4672 28.7149 55.8424 28.0873 55.4079 27.5631C54.9869 27.0553 54.8465 26.7612 54.7894 26.5329C54.6505 25.9785 54.7292 25.293 54.9901 24.7846C55.1022 24.566 55.3 24.3186 55.7898 23.9432C56.3017 23.5506 57.0086 23.1081 58.0733 22.4445C76.3028 11.0833 97.8756 4.5 120.955 4.5Z'
            stroke='white'
            strokeWidth='3'
          />
          <path
            d='M185.42 19.8967C166.7 8.24918 144.612 1.5 120.955 1.5C97.2982 1.5 75.1779 8.24937 56.4866 19.8985L56.4264 19.936C55.4377 20.5522 54.6055 21.0708 53.9643 21.5624C53.2879 22.0811 52.7134 22.6498 52.3208 23.4153C51.728 24.5708 51.5638 26.0019 51.8792 27.2617C52.0908 28.1063 52.5405 28.8048 53.0982 29.4777C53.6324 30.1221 54.3575 30.8479 55.2271 31.7183L55.2765 31.7677L84.5019 61.023L84.5347 61.0559C85.1073 61.629 85.5861 62.1083 86.0058 62.4783C86.4433 62.8639 86.8887 63.1971 87.4152 63.4346C88.2609 63.8162 89.0751 63.9664 90.0013 63.9116C90.5893 63.8769 91.1494 63.7105 91.7203 63.4941C92.2775 63.283 92.9476 62.9828 93.761 62.6185L93.8023 62.6C102.088 58.8889 111.261 56.8471 120.955 56.8471C130.644 56.8471 139.819 58.8864 148.078 62.5921L148.119 62.6105C148.935 62.9763 149.606 63.2775 150.164 63.4895C150.735 63.7066 151.296 63.8737 151.884 63.9089C152.811 63.9642 153.625 63.8146 154.471 63.4333C154.998 63.196 155.444 62.8627 155.882 62.4771C156.302 62.1071 156.781 61.6276 157.355 61.0542L157.388 61.0211L186.634 31.775L186.683 31.7257C187.555 30.8542 188.281 30.1276 188.817 29.4826C189.375 28.8092 189.826 28.1101 190.038 27.2647C190.354 26.0038 190.189 24.5722 189.596 23.4158C189.202 22.6496 188.626 22.0806 187.949 21.5618C187.306 21.0698 186.472 20.5508 185.48 19.934L185.42 19.8967Z'
            stroke='#F7C604'
            strokeWidth='3'
          />
          <defs>
            <linearGradient id='paint0_linear_78_12' x1='227' y1='62' x2='166' y2='95' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#13CE76' />
              <stop offset='1' stopColor='#11BD6C' />
            </linearGradient>
          </defs>
        </svg>
      )}

      <svg
        style={{
          position: 'absolute',
          bottom: -16,
          left: -40,
          zIndex: 3
        }}
        width='311'
        height='20'
        viewBox='0 0 311 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect width='311' height='20' fill='white' />
      </svg>
    </div>
  )
}

const CustomizedLabel = props => {
  const { x, y, stroke, value } = props
  return value == '28' ? null : (
    <text x={x} y={y} dy={-8} fill={stroke} fontSize={16} textAnchor='middle'>
      {value}
    </text>
  )
}

const renderTooltip = some => {
  if (some.payload) {
    return (
      <div
        style={{
          backgroundColor: '#303051F2',
          padding: '16px 20px',
          color: '#fff',
          borderRadius: '8px'
        }}
      >
        <div className='column'>
          <p style={{ fontWeight: 600, marginBottom: 6 }}>{some.payload[0]?.payload.name}</p>
          <div style={{ marginBottom: 6 }} className='row row-center'>
            <p style={{ fontSize: '14px', opacity: 0.7 }}>Risky Users: </p>
            <p style={{ marginLeft: 6 }}> {some.payload[0]?.payload.riskyUsersCount}</p>
          </div>
        </div>
      </div>
    )
  }
}

const DashBoardNew = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [timePeriod] = useContext(DashBoardDateContext)

  const navigate = useNavigate()
  const [employeeStats, setEmployeeStats] = useState(null)
  const [microtrainingStats, setMicrotrainingStats] = useState(null)
  const [threats, setThreats] = useState(null)
  const [loading, setLoading] = useState(false)

  const [stats, setStats] = useState(null)
  const [trainingsStats, setTrainingsStats] = useState(null)
  const [workflowStats, setWorkflowStats] = useState(null)
  const [overalSecurityScoreMonthly, setOveralSecurityScoreMonthly] = useState([])

  const timePeriod3Month = {
    timePeriod: 'CUSTOM',
    startDate: dayjs(timePeriod?.endDate).subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
    endDate: timePeriod?.endDate
  }

  const emptyChart = [
    {
      name: '',
      fullName: '',
      phishing: 0
    },
    {
      name: '',
      fullName: '',
      phishing: 0
    }
  ]

  const getAllData = () => {
    setLoading(true)
    Promise.all([
      statsService.getCurrentCompanyStats(timePeriod),
      statsService.getCurrentCompanyMicroTrainingStats(timePeriod),
      statsService.getCurrentCompanySimulationStats(timePeriod),
      statsService.getCurrentCompanySecurityTrainingStats(timePeriod),
      statsService.getCurrentCompanyOveralSecurityScoreMonthly(timePeriod),
      statsService.getCurrentCompanyExternalPhishing(timePeriod),
      statsService.getCurrentCompanyWorkflowStats(timePeriod3Month),
      statsService.getCurrentCompanyWorkflowStatsMonthly(timePeriod3Month)
    ])
      .then(
        values => {
          const [
            employeeStatsResp,
            microtrainingStatsResp,
            simStatsResp,
            currentCompanySecurityTrainingStatsResp,
            overalSecurityScoreRespMonthly,
            reportedEmailsResp,
            companyWorkflowStatsResp,
            companyWorkflowStatsMonthlyResp
          ] = values

          setEmployeeStats(employeeStatsResp.data)
          setMicrotrainingStats(microtrainingStatsResp.data)
          setStats(simStatsResp.data)
          setThreats(reportedEmailsResp.data)
          setTrainingsStats(currentCompanySecurityTrainingStatsResp.data)
          setWorkflowStats({
            chart: companyWorkflowStatsMonthlyResp.data,
            categories: companyWorkflowStatsResp.data
          })
          setOveralSecurityScoreMonthly(overalSecurityScoreRespMonthly.data)

          setLoading(false)
        },
        err => {
          if (err.response.status == 401) {
            navigate('/login')
          }
        }
      )
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (timePeriod) {
      getAllData()
    }
  }, [timePeriod])

  function getChartData(data) {
    const indexOfCurrent = data?.findIndex(el => dayjs(el.month).month() == dayjs(timePeriod?.endDate).month())
    const res = data.slice(0, indexOfCurrent + 1).slice(-3)

    return res.map(el => ({
      name: dayjs(el.month).format('MMM'),
      phishing: Math.round(el.securityScore)
    }))
  }

  const chartData = overalSecurityScoreMonthly ? getChartData(overalSecurityScoreMonthly) : emptyChart

  const nonNullOvSecScore = overalSecurityScoreMonthly.filter(el => el.securityScore !== 0)

  const overalSecurityScore = nonNullOvSecScore?.length
    ? nonNullOvSecScore.reduce((sum, item) => sum + item.securityScore, 0) / nonNullOvSecScore.length
    : 0

  const getProgressionOverTimeLabel = () => {
    let currentMonthItemIndex = overalSecurityScoreMonthly?.findIndex(
      el => dayjs(el.month).month() == dayjs(timePeriod?.endDate).month()
    )
    const currentMonthItem = overalSecurityScoreMonthly[currentMonthItemIndex]

    return currentMonthItem?.securityScore < 33 ? 3 : currentMonthItem?.securityScore > 66 ? 1 : 2
  }

  const threatsData = {
    totalCount: threats?.totalCount,
    unsorted: threats?.noDecisionCount,
    safe: threats?.safeCount,
    fraud: threats?.fishingCount
  }

  const riskyCategoriesData = workflowStats?.categories
  function RiskyUsersPercentSinceTime() {
    const current = workflowStats?.chart[workflowStats?.chart.length - 1]?.riskyUsersCount
    const prev = workflowStats?.chart[workflowStats?.chart.length - 3]?.riskyUsersCount

    if (current == prev) {
      return (
        <span className={'green-text'} style={{ marginRight: 6 }}>
          0% Up
        </span>
      )
    }
    if (current > prev) {
      return (
        <div className='row row-center'>
          <svg width='14' height='7' viewBox='0 0 14 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M7.19437 0.2L13.4184 6.408L0.970374 6.408L7.19437 0.2Z' fill='#ED4563' />
          </svg>
          <span className={'red-text'} style={{ marginRight: 6 }}>
            {prev == 0 ? '100' : Math.round((current * 100) / prev)}%
          </span>
          <span style={{ marginRight: 6 }}>Up </span>
        </div>
      )
    }
    if (current < prev) {
      return (
        <div className='row row-center'>
          <svg
            style={{ transform: 'rotate(180deg)', marginRight: 8 }}
            width='14'
            height='7'
            viewBox='0 0 14 7'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M7.19437 0.2L13.4184 6.408L0.970374 6.408L7.19437 0.2Z' fill='#00bc62' />
          </svg>
          <span className={'green-text'} style={{ marginRight: 6 }}>
            {current == 0 ? '100' : Math.round((current * 100) / prev)}%
          </span>
          <span style={{ marginRight: 6 }}>Less </span>
        </div>
      )
    }
  }

  return (
    <div
      className='column'
      style={{
        backgroundColor: '#F8F8FB',
        height: '100vh',
        overflowY: 'auto',
        padding: '24px'
      }}
    >
      <div className='container-1089' style={{ minHeight: '100vh' }}>
        <OnboardingStack />
        <PageHeading>
          <PageTitle>Dashboard</PageTitle>
          <PeriodPicker />
        </PageHeading>

        {loading ? (
          <LoadingIndicator />
        ) : (
          <>
            <DashBoardSection>
              <DashBoardSectionTitle>Summary</DashBoardSectionTitle>
              <Row>
                <DashBoardSectionBlock style={{ width: 'calc(50% - 4px)' }}>
                  <Row>
                    <DashBoardSectionBlockTitle>Overall security score</DashBoardSectionBlockTitle>
                    <Spacer />
                    <DashBoardSectionlabel
                      type={overalSecurityScore < 33 ? 3 : overalSecurityScore > 66 ? 1 : 2}
                    ></DashBoardSectionlabel>
                  </Row>
                  <Spacer />
                  <Row style={{ alignItems: 'flex-end' }}>
                    <p className='big-num-72'>{Math.round(overalSecurityScore)}</p>
                    <Spacer />
                    <OveralScoreIndicator score={overalSecurityScore} />
                  </Row>
                </DashBoardSectionBlock>
                <Spacer />

                <DashBoardSectionBlock style={{ width: 'calc(50% - 4px)' }}>
                  <Row style={{ marginBottom: 10 }}>
                    <div style={{ width: '100%' }} className='column'>
                      <div className='row row-center'>
                        <DashBoardSectionBlockTitle>Progression over time</DashBoardSectionBlockTitle>
                        <Spacer />
                        <DashBoardSectionlabel type={getProgressionOverTimeLabel()}></DashBoardSectionlabel>
                      </div>
                      <DashBoardSectionBlockSubTitle>For last 3 month</DashBoardSectionBlockSubTitle>
                    </div>
                  </Row>

                  <ResponsiveContainer width='100%' height={180}>
                    <AreaChart
                      data={chartData}
                      margin={{
                        top: 20,
                        right: 30,
                        left: 30,
                        bottom: 0
                      }}
                    >
                      <defs>
                        <linearGradient id='colorUv' x1='0' y1='0' x2='0' y2='1'>
                          <stop offset='5%' stopColor='#6123FF' stopOpacity={0.4} />
                          <stop offset='95%' stopColor='#6123FF' stopOpacity={0} />
                        </linearGradient>
                      </defs>
                      <XAxis dataKey='name' />
                      {/* <YAxis /> */}
                      <CartesianGrid horizontal={false} strokeDasharray='3 3' />
                      {/* <Tooltip /> */}
                      {/* <Area type="monotone" dataKey="uv" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" label={<CustomizedLabel />} /> */}
                      <Area
                        dot={{ r: 2 }}
                        type='monotone'
                        dataKey='phishing'
                        stroke='#6123FF'
                        strokeWidth={2}
                        fillOpacity={1}
                        fill='url(#colorUv)'
                        label={<CustomizedLabel />}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </DashBoardSectionBlock>
              </Row>
            </DashBoardSection>

            <DashBoardSection>
              <DashBoardSectionTitle>Simulations</DashBoardSectionTitle>
              <Row>
                <DashBoardSectionBlock style={{ width: 'calc(50% - 4px)' }}>
                  <Row>
                    <div className='column'>
                      <DashBoardSectionBlockTitle>Phishing click rate</DashBoardSectionBlockTitle>
                      {/* <DashBoardSectionBlockSubTitle>Lower by <span className='green-text' style={{ margin: '0px 6px' }}>30%

                      <svg style={{ margin: '0px 0px 3px 5px' }} width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.529236 0.196875H8.52924L4.52924 5.79688L0.529236 0.196875Z" fill="#00BC62" />
                      </svg>
                    </span>
                      compared to March</DashBoardSectionBlockSubTitle> */}
                    </div>
                    <Spacer />
                    <DashBoardSectionlabel
                      type={stats?.phishedPercentage < 33 ? 1 : stats?.phishedPercentage > 66 ? 3 : 2}
                    ></DashBoardSectionlabel>
                  </Row>

                  <Row
                    style={{
                      marginTop: 25,
                      marginBottom: 32
                    }}
                  >
                    <div
                      className='column'
                      style={{
                        marginRight: 6,
                        alignItems: 'end'
                      }}
                    >
                      <div
                        className='row row-center'
                        style={{
                          height: 36,
                          textAlign: 'right',
                          marginBottom: 2
                        }}
                      >
                        <p className='secondary-text-16'>{stats?.totalCount == 0 ? '0' : '100'}%</p>
                      </div>
                      <div
                        className='row row-center'
                        style={{
                          height: 36,
                          textAlign: 'right',
                          marginBottom: 2
                        }}
                      >
                        <p className='secondary-text-16'>{stats?.openedPercentage}%</p>
                      </div>
                      <div
                        className='row row-center'
                        style={{
                          height: 36,
                          textAlign: 'right',
                          marginBottom: 2
                        }}
                      >
                        <p className='secondary-text-16'>{stats?.phishedPercentage}%</p>
                      </div>
                      <div
                        className='row row-center'
                        style={{
                          height: 36,
                          textAlign: 'right',
                          marginBottom: 2
                        }}
                      >
                        <p className='secondary-text-16'>{stats?.reportedPercentage}%</p>
                      </div>
                    </div>
                    <div className='column' style={{ flex: 1 }}>
                      <div
                        style={{
                          padding: 10,
                          height: 36,
                          borderRadius: '5px',
                          marginBottom: 2,
                          position: 'relative',
                          overflow: 'hidden'
                        }}
                        className='row row-center dash'
                      >
                        <div
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: stats?.totalCount == 0 ? '0%' : '100%',
                            overflow: 'hidden'
                          }}
                        >
                          <svg
                            width='430'
                            height='36'
                            viewBox='0 0 430 36'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <g opacity='0.7'>
                              <path
                                opacity='0.1'
                                d='M-81.3086 55.3402L16.1939 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path opacity='0.1' d='M150 55.3402L247.502 -9.875' stroke='#292929' strokeWidth='5' />
                              <path
                                opacity='0.1'
                                d='M-64.7656 55.3402L32.7368 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M166.543 55.3402L264.045 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M-48.2266 55.3402L49.2759 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M183.082 55.3402L280.585 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M-31.6875 55.3402L65.815 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M199.621 55.3402L297.124 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M-15.1445 55.3402L82.3579 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M216.164 55.3402L313.667 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path opacity='0.1' d='M1.39453 55.3402L98.897 -9.875' stroke='#292929' strokeWidth='5' />
                              <path
                                opacity='0.1'
                                d='M232.703 55.3402L330.206 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M17.9336 55.3402L115.436 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M249.242 55.3402L346.745 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M34.4766 55.3402L131.979 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M265.785 55.3402L363.288 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M51.0156 55.3402L148.518 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M282.324 55.3402L379.827 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M67.5586 55.3402L165.061 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path opacity='0.1' d='M298.867 55.3402L396.37 -9.875' stroke='#292929' strokeWidth='5' />
                              <path opacity='0.1' d='M84.0977 55.3402L181.6 -9.875' stroke='#292929' strokeWidth='5' />
                              <path
                                opacity='0.1'
                                d='M315.406 55.3402L412.909 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M100.641 55.3402L198.143 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M331.949 55.3402L429.452 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path opacity='0.1' d='M117.18 55.3402L214.682 -9.875' stroke='#292929' strokeWidth='5' />
                              <path
                                opacity='0.1'
                                d='M348.488 55.3402L445.991 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path
                                opacity='0.1'
                                d='M133.719 55.3402L231.221 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path opacity='0.1' d='M365.027 55.3402L462.53 -9.875' stroke='#292929' strokeWidth='5' />
                              <path
                                opacity='0.1'
                                d='M382.488 55.3402L479.991 -9.875'
                                stroke='#292929'
                                strokeWidth='5'
                              />
                              <path opacity='0.1' d='M399.027 55.3402L496.53 -9.875' stroke='#292929' strokeWidth='5' />
                            </g>
                          </svg>
                        </div>
                        <p
                          style={{
                            zIndex: 10,
                            fontWeight: 500
                          }}
                        >
                          Total attacks sent
                        </p>
                        <Spacer />
                        <p
                          style={{
                            zIndex: 10,
                            fontWeight: 500,
                            fontSize: '20px',
                            fontFamily: 'Satoshi'
                          }}
                        >
                          {stats?.totalCount}
                        </p>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          height: 36,
                          position: 'relative',
                          marginBottom: 2
                        }}
                        className='row row-center'
                      >
                        <div
                          style={{
                            position: 'absolute',
                            width: stats?.openedPercentage + '%',
                            top: 0,
                            left: 0,
                            height: '100%',
                            background: '#E0E8F7',
                            borderRadius: '5px'
                          }}
                        ></div>
                        <p
                          style={{
                            zIndex: 10,
                            fontWeight: 500
                          }}
                        >
                          Opened
                        </p>
                        <Spacer />
                        <p
                          style={{
                            zIndex: 10,
                            fontWeight: 500,
                            fontSize: '20px',
                            fontFamily: 'Satoshi'
                          }}
                        >
                          {stats?.openedCount}
                        </p>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          height: 36,
                          position: 'relative',
                          marginBottom: 2
                        }}
                        className='row row-center'
                      >
                        <div
                          style={{
                            position: 'absolute',
                            width: stats?.phishedPercentage + '%',
                            top: 0,
                            left: 0,
                            height: '100%',
                            background: '#F2D5CC',
                            borderRadius: '5px'
                          }}
                        ></div>
                        <p
                          style={{
                            zIndex: 10,
                            fontWeight: 500
                          }}
                        >
                          Phished
                        </p>
                        <Spacer />
                        <p
                          style={{
                            zIndex: 10,
                            fontWeight: 500,
                            fontSize: '20px',
                            fontFamily: 'Satoshi'
                          }}
                        >
                          {stats?.phishedCount}
                        </p>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          height: 36,
                          position: 'relative'
                        }}
                        className='row row-center'
                      >
                        <div
                          style={{
                            position: 'absolute',
                            width: stats?.reportedPercentage + '%',
                            top: 0,
                            left: 0,
                            height: '100%',
                            background: '#01BD6325',
                            borderRadius: '5px'
                          }}
                        ></div>
                        <p
                          style={{
                            zIndex: 10,
                            fontWeight: 500
                          }}
                        >
                          Reported
                        </p>
                        <Spacer />
                        <p
                          style={{
                            zIndex: 10,
                            fontWeight: 500,
                            fontSize: '20px',
                            fontFamily: 'Satoshi'
                          }}
                        >
                          {stats?.reportedCount}
                        </p>
                      </div>
                    </div>
                  </Row>

                  <SeeDetails link={'/phishing-click-rate'} />
                </DashBoardSectionBlock>
                <Spacer />
                <DashBoardSectionBlock style={{ width: 'calc(50% - 4px)' }}>
                  <Row>
                    <DashBoardSectionBlockTitle>Phishing Micro-training followed</DashBoardSectionBlockTitle>
                    <Spacer />
                    <DashBoardSectionlabel
                      type={
                        getPercent(microtrainingStats?.totalCount, microtrainingStats?.completedCount) < 33
                          ? 3
                          : getPercent(microtrainingStats?.totalCount, microtrainingStats?.completedCount) > 66
                            ? 1
                            : 2
                      }
                    >
                      Weak
                    </DashBoardSectionlabel>
                  </Row>
                  <p className='big-num-72'>
                    {getPercent(microtrainingStats?.totalCount, microtrainingStats?.completedCount)}%
                  </p>
                  {/* {microtrainingStats?.enrolledUsersCount ? <p className='secondary-text-16' style={{ maxWidth: 267 }}>{microtrainingStats?.enrolledUsersCount} employees followed remedial micro-training</p> : null} */}
                  {employeeStats?.totalCount ? (
                    <p className='secondary-text-16' style={{ maxWidth: 267 }}>
                      {microtrainingStats?.followedUsersCount} employees followed remedial micro-training
                    </p>
                  ) : null}
                  <Spacer />
                  <SeeDetails link={'/phishing-micro-training-followed'} />
                </DashBoardSectionBlock>
              </Row>
            </DashBoardSection>

            <DashBoardSection>
              <DashBoardSectionTitle>Security Awareness</DashBoardSectionTitle>
              <Row style={{ marginBottom: 8 }}>
                <DashBoardSectionBlock style={{ width: 'calc(50% - 4px)' }}>
                  <Row>
                    <div className='column'>
                      <DashBoardSectionBlockTitle>Coverage rate</DashBoardSectionBlockTitle>
                    </div>
                    <Spacer />
                    <Info style={{ margin: 0 }} text={'We recomend to cover the whole team'} />
                  </Row>
                  <RowCenter
                    style={{
                      marginTop: 47,
                      marginBottom: 16
                    }}
                  >
                    <p className='big-num-36'>{trainingsStats?.enrolledUsersPercentage}%</p>
                    <p
                      className='secondary-text-16'
                      style={{
                        maxWidth: 220,
                        marginLeft: 10
                      }}
                    >
                      of your team will receive courses this year
                    </p>
                  </RowCenter>
                  <div
                    style={{
                      width: '100%',
                      height: 10,
                      background: '#1B1B2626',
                      borderRadius: 10,
                      marginBottom: 15
                    }}
                  >
                    <div
                      style={{
                        width: trainingsStats?.enrolledUsersPercentage + '%',
                        height: 10,
                        background: '#0FA9FF',
                        borderRadius: 10
                      }}
                    ></div>
                  </div>
                  <RowCenter>
                    <p className='secondary-text-16' style={{ fontWeight: 600 }}>
                      {trainingsStats?.enrolledUsersCount} users covered
                    </p>
                    <Spacer />
                    <p className='secondary-text-16' style={{ fontWeight: 600 }}>
                      {employeeStats?.totalCount} total
                    </p>
                  </RowCenter>
                </DashBoardSectionBlock>
                <Spacer />
                <DashBoardSectionBlock style={{ width: 'calc(50% - 4px)' }}>
                  <Row>
                    <DashBoardSectionBlockTitle>Trainings pass</DashBoardSectionBlockTitle>
                    <Spacer />
                  </Row>
                  <RowCenter
                    style={{
                      marginTop: 47,
                      marginBottom: 16
                    }}
                  >
                    <p className='big-num-36'>
                      {getPercent(trainingsStats?.totalCount, trainingsStats?.completedCount)}%
                    </p>
                    <p
                      className='secondary-text-16'
                      style={{
                        maxWidth: 137,
                        marginLeft: 10
                      }}
                    >
                      completion of training packages
                    </p>
                  </RowCenter>
                  <div
                    style={{
                      width: '100%',
                      height: 10,
                      background: '#1B1B2626',
                      borderRadius: 10,
                      marginBottom: 15
                    }}
                  >
                    <div
                      style={{
                        width: getPercent(trainingsStats?.totalCount, trainingsStats?.completedCount) + '%',
                        height: 10,
                        background: '#0FA9FF',
                        borderRadius: 10
                      }}
                    ></div>
                  </div>
                  <RowCenter>
                    <p className='secondary-text-16' style={{ fontWeight: 600 }}>
                      {trainingsStats?.completedCount} trainings complete
                    </p>
                    <Spacer />
                    <p className='secondary-text-16' style={{ fontWeight: 600 }}>
                      {trainingsStats?.totalCount} total
                    </p>
                  </RowCenter>
                </DashBoardSectionBlock>
              </Row>

              <Row>
                <DashBoardSectionBlock style={{ width: 'calc(50% - 4px)' }}>
                  <Row>
                    <div className='column'>
                      <DashBoardSectionBlockTitle>Drop rate</DashBoardSectionBlockTitle>
                    </div>
                    <Spacer />
                    <DashBoardSectionlabel
                      type={
                        getPercent(trainingsStats?.totalCount, trainingsStats?.missedCount) < 33
                          ? 1
                          : getPercent(trainingsStats?.totalCount, trainingsStats?.missedCount) > 66
                            ? 3
                            : 2
                      }
                    >
                      Average
                    </DashBoardSectionlabel>
                  </Row>

                  <p className='big-num-72'>{getPercent(trainingsStats?.totalCount, trainingsStats?.missedCount)}%</p>
                  <p style={{ fontWeight: 600 }} className='secondary-text-16'>
                    Abandoned courses
                  </p>
                </DashBoardSectionBlock>
                <Spacer />
                <DashBoardSectionBlock style={{ width: 'calc(50% - 4px)' }}>
                  <Row>
                    <DashBoardSectionBlockTitle>Average trainings assigned to user</DashBoardSectionBlockTitle>
                    <Spacer />
                  </Row>

                  <p className='big-num-72'>
                    {trainingsStats?.totalCount &&
                      employeeStats?.totalCount &&
                      Math.round(trainingsStats?.totalCount / employeeStats?.totalCount)}
                  </p>
                  <p
                    className='secondary-text-16'
                    style={{
                      maxWidth: 370,
                      fontWeight: 600
                    }}
                  >
                    This is the average number of trainings assigned to an employee in your team
                  </p>
                </DashBoardSectionBlock>
              </Row>
            </DashBoardSection>

            <DashBoardSection>
              <DashBoardSectionTitle>Reported Threats</DashBoardSectionTitle>
              <Row>
                <DashBoardSectionBlock style={{ width: 'calc(50% - 4px)' }}>
                  <Row>
                    <div className='column'>
                      <DashBoardSectionBlockTitle>Reported emails</DashBoardSectionBlockTitle>
                      <DashBoardSectionBlockSubTitle>
                        Increased to {threatsData.totalCount}, indicating enhanced
                        <span
                          className={
                            getPercent(threatsData.totalCount, threatsData.fraud) > 40 ? 'green-text' : 'red-text'
                          }
                          style={{ marginLeft: 6 }}
                        >
                          vigilance
                          <svg
                            style={{
                              margin: '0px 0px 0px 5px',
                              transform:
                                getPercent(threatsData.totalCount, threatsData.fraud) > 40
                                  ? 'rotate(180deg)'
                                  : 'rotate(0deg)'
                            }}
                            width='9'
                            height='6'
                            viewBox='0 0 9 6'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M0.529236 0.196875H8.52924L4.52924 5.79688L0.529236 0.196875Z'
                              fill={getPercent(threatsData.totalCount, threatsData.fraud) > 40 ? '#00BC62' : '#ED4563'}
                            />
                          </svg>
                        </span>
                      </DashBoardSectionBlockSubTitle>
                    </div>
                  </Row>

                  <Row
                    style={{
                      justifyContent: 'space-between',
                      marginTop: 32,
                      marginBottom: 24
                    }}
                  >
                    <div
                      className='column'
                      style={{
                        padding: '10px 12px',
                        height: 155,
                        width: 'calc((100% - 36px)/4)',
                        border: '1px solid #1B1B260D',
                        borderRadius: 6
                      }}
                    >
                      <p>Total reports</p>
                      <Spacer />
                      <p className='big-num-28'>{threatsData.totalCount}</p>
                    </div>
                    <div
                      className='column'
                      style={{
                        padding: '10px 12px',
                        height: 155,
                        width: 'calc((100% - 36px)/4)',
                        border: threatsData.unsorted > 2 ? '1px solid #ED4563' : '1px solid #1B1B260D',
                        borderRadius: 6,
                        background:
                          threatsData.unsorted > 2 &&
                          'linear-gradient(0deg, rgba(247, 230, 224, 0.25), rgba(247, 230, 224, 0.25)), linear-gradient(180deg, rgba(247, 230, 224, 0) 0%, rgba(251, 174, 147, 0.08) 100%)'
                      }}
                    >
                      <p>Unsorted</p>
                      <Spacer />
                      <p
                        style={{
                          color: threatsData.unsorted > 2 ? '#ED4563' : '#1B1B268a',
                          fontSize: 14
                        }}
                      >
                        {threatsData.unsorted} email
                      </p>
                      <p className='big-num-28'>{getPercent(threatsData.totalCount, threatsData.unsorted)}%</p>
                    </div>
                    <div
                      className='column'
                      style={{
                        padding: '10px 12px',
                        height: 155,
                        width: 'calc((100% - 36px)/4)',
                        border: '1px solid #1B1B260D',
                        borderRadius: 6
                      }}
                    >
                      <p>Safe</p>
                      <Spacer />
                      <p
                        style={{
                          color: '#1B1B268a',
                          fontSize: 14
                        }}
                      >
                        {threatsData.safe} email
                      </p>
                      <p className='big-num-28'>{getPercent(threatsData.totalCount, threatsData.safe)}%</p>
                    </div>
                    <div
                      className='column'
                      style={{
                        padding: '10px 12px',
                        height: 155,
                        width: 'calc((100% - 36px)/4)',
                        border: '1px solid #1B1B260D',
                        borderRadius: 6
                      }}
                    >
                      <p>Fraudulent</p>
                      <Spacer />
                      <p
                        style={{
                          color: '#1B1B268a',
                          fontSize: 14
                        }}
                      >
                        {threatsData.fraud} email
                      </p>
                      <p className='big-num-28'>{getPercent(threatsData.totalCount, threatsData.fraud)}%</p>
                    </div>
                  </Row>

                  <SeeDetails link={'/threats'} />
                </DashBoardSectionBlock>
                <Spacer />
                <ActiveReportingUsers timePeriod={timePeriod3Month} totalUsers={employeeStats?.totalCount} />
              </Row>
            </DashBoardSection>

            <DashBoardSection>
              <DashBoardSectionTitle>Risky Behaviors</DashBoardSectionTitle>
              <Row>
                <DashBoardSectionBlock style={{ width: '100%' }}>
                  <Row
                    style={{
                      padding: '0px 0px 30px 0px'
                    }}
                  >
                    <div className='column' style={{ marginBottom: 0 }}>
                      <DashBoardSectionBlockTitle>Risky behaviors by category</DashBoardSectionBlockTitle>
                      <DashBoardSectionBlockSubTitle>
                        <RiskyUsersPercentSinceTime /> since for last 3 month
                      </DashBoardSectionBlockSubTitle>
                    </div>
                  </Row>

                  <Row
                    style={{
                      marginBottom: 10,
                      flexWrap: 'wrap'
                    }}
                  >
                    {riskyCategoriesData
                      ?.sort((a, b) => {
                        if (a.riskyUsersPercentage < b.riskyUsersPercentage) {
                          return 1
                        }
                        if (a.riskyUsersPercentage > b.riskyUsersPercentage) {
                          return -1
                        }
                        return 0
                      })
                      .slice(0, 3)
                      .map(el => (
                        <div key={el.id} className='column risky-element' style={{ width: '30%' }}>
                          <Row
                            style={{
                              marginBottom: '20px',
                              height: '50px',
                              alignItems: 'flex-end'
                            }}
                          >
                            <p
                              className='text-shrink-2'
                              style={{
                                fontWeight: 500,
                                maxWidth: '200px'
                              }}
                            >
                              {el.name}
                            </p>
                            <Spacer />
                            <p
                              style={{
                                lineHeight: '30px'
                              }}
                              className='big-num-36'
                            >
                              {el.riskyUsersPercentage > 100 ? 100 : el.riskyUsersPercentage}%
                            </p>
                          </Row>

                          <div
                            style={{
                              width: '100%',
                              height: 10,
                              background: '#1B1B2626',
                              borderRadius: 10,
                              marginBottom: 15
                            }}
                          >
                            <div
                              style={{
                                width: el.riskyUsersPercentage > 100 ? 100 : el.riskyUsersPercentage + '%',
                                height: 10,
                                background: 'linear-gradient(90deg, #EF5C77 0%, #F44C6B 100%)',
                                borderRadius: 10
                              }}
                            ></div>
                          </div>

                          <div className='row row-center'>
                            {el.service == 'CYBERLIFT' && <img src={'images/wf3.png'} width={28} alt='' />}
                            {el.service == 'HAVE_I_BEEN_PWNED' && <img src={'images/wf4.png'} width={28} alt='' />}
                            {el.service == 'GMAIL' && <img src={'images/wf5.png'} width={28} alt='' />}
                            {el.service == 'OUTLOOK' && <img src={'images/wf6.png'} width={28} alt='' />}
                            <p
                              style={{
                                fontSize: 13,
                                color: '#76767F',
                                marginLeft: 12,
                                textTransform: 'capitalize',
                                marginRight: 20
                              }}
                            >
                              {el && el.service.replaceAll('_', ' ').toLowerCase().replaceAll('cyberlift', 'NJSIG')}
                            </p>
                          </div>
                        </div>
                      ))}
                  </Row>
                  <SeeDetails link={'/all-risks'} text='See all risks' />
                </DashBoardSectionBlock>
              </Row>
            </DashBoardSection>
          </>
        )}
        <DashboardFooterLogo />
      </div>
    </div>
  )
}

export default DashBoardNew
